import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import VUSeal from './VUSeal'
import './Orientation.css'

const STEPS = [
  {
    icon: '🎓',
    title: 'Welcome to Vacatia University',
    body: 'This is your personal dashboard for Curriculum 01: Branding. Every module, every resource, and every note between you and Sam lives here. It is yours to come back to anytime.',
  },
  {
    icon: '📋',
    title: 'How modules work',
    body: 'Each module has a pre-work checklist to complete before the live session, a Google Meet link to join the call, and a recording that appears here after the session ends. Work through them at your own pace.',
  },
  {
    icon: '📚',
    title: 'Your resource library',
    body: 'Below your modules you will find your full brand toolkit - the Vacatia Brand Resources folder and the Vacatia Claude Project for on-brand writing help. These are yours permanently, not just for the duration of the curriculum.',
  },
  {
    icon: '💬',
    title: 'Notes with Sam',
    body: 'At the bottom of each module page is a notes field. Leave a question, a win, or a challenge after any session. Sam will write back directly inside the platform and you will receive an email when there is a response.',
  },
  {
    icon: '✓',
    title: "You're all set",
    body: 'Module 1 begins November 4, 2026. You will receive an email with the date and Google Meet link shortly. Until then, explore your dashboard and reach out to Sam at sam.ghanem@vacatia.com with any questions.',
  },
]

export default function Orientation({ onComplete }) {
  const [step, setStep] = useState(0)
  const navigate = useNavigate()
  const current = STEPS[step]
  const isLast = step === STEPS.length - 1

  const handleNext = () => {
    if (isLast) {
      onComplete()
    } else {
      setStep(step + 1)
    }
  }

  return (
    <div className="orient">
      <div className="orient-card">
        <div className="orient-seal"><VUSeal size={80} /></div>
        <div className="orient-icon">{current.icon}</div>
        <h2 className="orient-title">{current.title}</h2>
        <p className="orient-body">{current.body}</p>
        <div className="orient-dots">
          {STEPS.map((_, i) => (
            <span key={i} className={`orient-dot ${i === step ? 'active' : ''}`} />
          ))}
        </div>
        <button className="orient-btn" onClick={handleNext}>
          {isLast ? 'Go to my dashboard' : 'Next'}
        </button>
        {!isLast && (
          <button className="orient-skip" onClick={onComplete}>Skip intro</button>
        )}
      </div>
    </div>
  )
}
